import { render } from "./Trade.vue?vue&type=template&id=8ad4f9a0&ts=true"
import script from "./Trade.vue?vue&type=script&lang=ts"
export * from "./Trade.vue?vue&type=script&lang=ts"

import "./Trade.vue?vue&type=style&index=0&id=8ad4f9a0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__